import React, { useState, useEffect } from 'react';
import { studentApi } from '../../services/api';

interface Institution {
  id: number | string;
  name: string;
  short_name?: string | null;
  logoUrl?: string | null;
  logo_url?: string | null;
}

const StudentInstitutions: React.FC = () => {
  const [institutions, setInstitutions] = useState<Institution[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    studentApi.institutions()
      .then((res) => setInstitutions(res.data || []))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-[20px] lg:text-[24px] font-semibold text-[#2b2b2b]">Kurumlarım</h1>
        <button className="bg-[#e5599b] text-white text-[14px] lg:text-[16px] font-semibold px-5 py-3 rounded-[12px] flex items-center gap-2 hover:bg-pink-600 transition-colors">
          <span className="text-[16px] lg:text-[20px]">+</span> Kurum Ekle
        </button>
      </div>

      {loading ? (
        <div className="flex justify-center py-16"><div className="w-8 h-8 border-4 border-[#3973bf] border-t-transparent rounded-full animate-spin" /></div>
      ) : institutions.length === 0 ? (
        <p className="text-center text-gray-400 py-16">Bağlı olduğun bir kurum yok.</p>
      ) : (
        <div className="flex gap-5 flex-wrap">
          {institutions.map((inst) => (
            <div key={inst.id} className="bg-[#fafafa] rounded-[20px] w-[229px] overflow-hidden" style={{ boxShadow: '0px 1px 4px rgba(0,0,0,0.12)' }}>
              <div className="h-[103px] bg-[#fafafa] flex items-center justify-center overflow-hidden">
                <img src={inst.logoUrl || inst.logo_url || '/a-sinif-tiling.png'} alt="" className="w-full h-full object-cover" />
              </div>
              <div className="p-4">
                <p className="text-[16px] lg:text-[20px] font-medium text-[#2b2b2b]">{inst.name}</p>
                <div className="flex justify-between items-center mt-2">
                  <button className="text-[#2b2b2b] text-[16px] lg:text-[20px]">•••</button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default StudentInstitutions;
